import { Duration } from 'effect'

import type { ChatEvent } from '../domain/chatEvents'

// 断片ごとの dispatch と再描画を抑えるため、受信した出来事をまとめる。
// 32ms は POC の計測で選んだ値（salescore-agent-docs の arch/frontend/reports/streaming-render.md、V4）。
export const RUNTIME_EVENT_BATCH_WINDOW = Duration.millis(32)

/**
 * ためた出来事のうち、同じ回答の隣り合う断片を1つにつなぐ。断片でない出来事はそのまま、届いた順に残す。
 * 回答の行の文字列を断片ごとに作り直さないためである。
 */
export const mergeAnswerDeltas = (events: readonly ChatEvent[]): readonly ChatEvent[] =>
  events.reduce<readonly ChatEvent[]>((merged, event) => {
    const last = merged.at(-1)
    if (event.kind === 'answerDelta' && last?.kind === 'answerDelta' && last.messageId === event.messageId) {
      return [...merged.slice(0, -1), { ...last, delta: last.delta + event.delta }]
    }
    return [...merged, event]
  }, [])
